import React from 'react';

import style from './NextSectionArrow.module.scss';

const NextSectionArrow = ({
  isLastSection,
  goToNextSection,
  isPlaylistOpen,
  arrowStyle,
  isLastChapter,
  isTimeline,
}) => {
  return (
    <div className={style.wrapper}>
      <div className={style.reveal}>
        <div
          className={`fadeOut js-nextSectionArrow ${style.downArrow} ${
            arrowStyle === 'white'
              ? style.whiteArrow
              : style.fillArrow + ' sectionFillArrow'
          } ${isLastSection ? style.nextChapter : ''}`}
          style={{ pointerEvents: isPlaylistOpen ? 'none' : 'auto' }}
          onClick={goToNextSection}
        >
          {isTimeline ? (
            <span>{'learn More'}</span>
          ) : (
            <span>{isLastChapter ? 'View Timeline' : 'Next Chapter'}</span>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="26"
            viewBox="0 0 23 26"
          >
            <title>Down Arrow</title>
            <polygon points="10.701 22.376 10.701 0 12.347 0 12.347 22.35 21.926 12.347 23.023 13.492 11.511 25.512 0 13.492 1.096 12.347" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default NextSectionArrow;



// WEBPACK FOOTER //
// ./src/components/chapter/NextSectionArrow.js